import { render, staticRenderFns } from "./WeCom.vue?vue&type=template&id=08e2476f&"
import script from "./WeCom.vue?vue&type=script&lang=js&"
export * from "./WeCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports